import React, { useState, useLayoutEffect, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { toggleModalWorkspaceCreate, diagramShare } from '../../../redux/main/main.actions';
import { selectIsModalWorkspaceCreateEnabled } from '../../../redux/main/main.selectors';

import {
    fetchDiagramMembers,
    changeRoleForDiagramMember,
    removeDiagramMember,
    fetchDiagramInvites,
    createDiagramInvite,
    revokeDiagramInvite,
} from '../../../redux/canvas/canvas.actions';
import { selectDiagramMembers, selectDiagramInvites } from '../../../redux/canvas/canvas.selectors';

import { showNotify } from '../../../redux/notify/notify.actions';

import Modal from '../Modal/Modal';

import { trackEvent } from '../../../lib/analytics';

import './ModalWorkspaceCreate.scss';
import ButtonDropdown from '../../../pages/MainApp/_components/ButtonDropdown/ButtonDropdown';

export const ModalWorkspaceCreate = () => {
    const dispatch = useDispatch();

    const isOpen = useSelector(selectIsModalWorkspaceCreateEnabled);

    const inputRef = useRef(null);

    const handleRender = () => {
        if (isOpen && inputRef.current) {
            inputRef.current.focus();
        }
    };

    //     const handleSave = () => {
    //         trackEvent('app_modal_diagram_rename_submit', {
    //             page: 'app',
    //             type: 'modals',
    //         });
    //         const updatedValue = value || 'Untitled';
    //         // setValue(updatedValue);
    //         dispatch(diagramRename(modalData?.diagram?.id, { title: updatedValue }));
    //         dispatch(toggleModalDiagramRename(null));

    //         setTimeout(() => {
    //             setValue(modalData?.diagram?.title || '');
    //         }, 300);
    //     };

    const handleCancel = () => {
        // dispatch(toggleModalWorkspaceCreate(null));

        // setTimeout(() => {
        //     setValue(modalData?.diagram?.title);
        // }, 300);
    };

    return (
        <Modal
            isOpen={isOpen}
            modalClass={`modal-workspace-create`}
            onCancel={handleCancel}
            onShouldRender={handleRender}
        >
            <div className="header">Create your workspace</div>
            <div className="form-group one">
                <div className="description-text">Enter workspace name</div>
                <input
                    className='input-with-role-input'
                    maxLength="1000"
                    ref={inputRef}
                    autoComplete="off"
                    spellCheck="false"
                    type="text"
                    id="diagram-name"
                    placeholder="Software Company Inc."
                    value={'My Workspace'}
                    // value={value}
                // onChange={(e) => setValue(e.target.value)}
                // onKeyDown={handleKeyDown}
                />
            </div>
            <button
            // onClick={() => handleSave()}
            >Continue</button>

            <div className="points">
                <div className="point selected"></div>
                <div className="point"></div>
            </div>

        </Modal>
    );
};

export default ModalWorkspaceCreate;
